<template>
  <nav
    class="nav"
    :style="{ zIndex: sortVisible ? '9999' : '1500' }"
    v-if="$route.name !== 'Welcome'"
    :class="{ changeNavStatus: !!changeNavStatus }"
  >
    <div class="nav-content">
      <!-- background -->
      <div class="nav-background">
        <div class="nav-background-stack"></div>
      </div>
      <div class="logo">
        <!--        <div-->
        <!--          class="logo-img"-->
        <!--          :class="{'keep-hue': !hideKeepHue}"-->
        <!--          @click="jumpToRoute('Home')"-->
        <!--          :style="{ backgroundImage: `url(${logo})`}"-->
        <!--        >-->
        <!--        </div>-->
        <img
          class="logo-img"
          :class="{ 'keep-hue': !hideKeepHue }"
          :src="logo"
          alt
          @click="jumpToRoute('Index', 'logo')"
        />
      </div>
      <div ref="userNav" class="nav-menu portalIndexNavMenu">
        <div
          class="nav-menu-item"
          v-for="nav in userNav.slice(0, navNumber)"
          :key="nav.pageCode"
          :class="{ 'nav-menu-item--active': currentNav === nav.pageCode }"
          @click="jumpToRoute(nav.pageCode)"
        >
          <b class="nav-menu-item-cursor" />
          <b class="nav-menu-item-background" :style="ieNavagationStyle" />
          <span>{{ nav.pageName }}</span>
        </div>
        <div
          class="nav-menu-item"
          v-show="userNav.length > navNumber"
          @click="openNavSort"
        >
          <b class="nav-menu-item-background" :style="ieNavagationStyle" />
          <i class="el-icon-more" />
        </div>
      </div>
      <div class="nav-content-iconSet">
        <!-- 老版门户地址 -->
        <div
          class="nav-content-iconSet-oldAddress"
          v-if="schoolCode === 'jiangxishifan'"
          @click="gotoOldportal"
          title="旧版门户"
        >
          <svg-icon icon="jxsfHome"></svg-icon>
        </div>
        <!-- 江西师范收藏夹 -->
        <div
          class="nav-content-iconSet-collect"
          v-if="schoolCode === 'jiangxishifan'"
          @click="gotoCollections"
          title="收藏夹"
        >
          <svg-icon icon="favorite"></svg-icon>
        </div>
        <!-- 全局搜索 -->
        <transition name="fade" mode="out-in" v-show="hasUserInfo">
          <i
            class="el-icon-search"
            v-if="globalSearchShow"
            @click="GlobalSearchVisible = true"
          />
          <!-- $router.push({name:'GlobalSearch'}) -->
          <z-search
            v-else
            class="nav-content-global-search"
            round
            v-model="globalSearchKeyword"
            @search="handleGetGlobalSearch"
            @blur="searchInputBlur"
          />
        </transition>
        <!-- 陕科大电话簿 -->
        <div
          class="nav-content-iconSet-telephone"
          v-if="schoolCode === 'shanxikejidaxue'"
          @click="gotoTelecontent"
          title="电话簿"
        >
          <svg-icon icon="telephone"></svg-icon>
        </div>
        <!--         帮助中心-->
        <svg-icon @click="jumpToRoute('HelpCenter')" icon="help" class="help" />
        <!-- 手机端、PC 端下载 -->
        <svg-icon
          icon="erCode"
          class="erCode"
          @click="$emit('showQrList')"
        ></svg-icon>
        <!-- 切换桌面 -->
        <div>
          <svg-icon
            @click="openDesktopSetting"
            :icon="changeThemeNavIcon || 'task-view'"
            class="desk"
          />
        </div>
        <!--        <div class="nav-content-iconSet-desktop">-->
        <!--          <div @click="openDesktopSetting">-->
        <!--            <svg-icon icon="task-view" clss="desk"/>-->
        <!--          </div>-->
        <!--        </div>-->
        <!-- 客服 -->
        <!--
        未完善，系统上线先注释掉
        <sw-icon icon="customer-service" @click.native="customerClick" />
        -->
        <!-- 消息铃铛 -->
        <el-badge
          :is-dot="false"
          class="keep-hue msgBadge"
          :hidden="!unReadedMessageCount"
          :value="unReadedMessageCount"
          v-show="hasUserInfo && unReadedMessageCount"
        >
          <sw-icon icon="bell" @click.native="messageClick" />
        </el-badge>
        <div
          class="el-badge keep-hue msgBadge"
          v-show="hasUserInfo && !unReadedMessageCount"
        >
          <sw-icon icon="bell" @click.native="messageClick" />
        </div>

        <!-- 登录 -->
        <span
          title="登录"
          class="nav-content-iconSet-login"
          v-show="!hasUserInfo"
          @click="login"
          >登录</span
        >
      </div>
      <!-- user center -->
      <div style="display: flex; align-items: center;" class="nav-avatar">
        <el-dropdown
          trigger="hover"
          @command="userCommand"
          placement="bottom"
          style="height: 40px;"
        >
          <el-link :underline="false">
            <el-avatar
              :src="avatarImg"
              class="avatar"
              :class="{ 'keep-hue': !hideKeepHue }"
              v-show="hasUserInfo && $route.name !== 'SignIn'"
            ></el-avatar>
          </el-link>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="userCenter">个人中心</el-dropdown-item>
            <el-dropdown-item command="goPlatform" v-if="superAmin"
              >云平台</el-dropdown-item
            >
            <!--
                    未完善，系统上线先注释掉
                    <el-dropdown-item command="switch">账号切换</el-dropdown-item>
                    -->
            <el-dropdown-item command="signOut" divided
              >安全退出</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 导航排序 -->
    <el-dialog
      append-to-body
      custom-class="nav-sort"
      top="60px"
      :visible.sync="sortVisible"
      :show-close="false"
      @close="submitNavSort"
    >
      <h4 class="nav-sort-title">
        <span>导航</span>
        <span style="display: none;">拖动进行排序，点击进行切换。</span>
      </h4>
      <draggable
        class="nav-sort-menu"
        draggable=".drag-ele"
        v-bind="dragOptions"
        :list="userNavTemp"
      >
        <div
          v-for="item in userNavTemp"
          :key="item.name"
          :class="[
            'nav-sort-menu-item',
            { 'drag-ele': item.pageCode !== 'Home' },
          ]"
        >
          <z-tag
            effect="dark"
            @click="jumpToRoute(item.pageCode)"
            v-tap="{ method: jumpToRoute, params: item.pageCode }"
            >{{ item.pageName }}</z-tag
          >
        </div>
      </draggable>
    </el-dialog>
    <!-- 嵌入的页面 -->
    <el-dialog
      fullscreen
      append-to-body
      destroy-on-close
      custom-class="nav-third_page app_dialog"
      :visible.sync="thirdPageVisible"
      @closed="thirdPageClosed"
    >
      <DesktopConfig v-if="desktopConfigVisible" @exit="exitDesktopConfig" />
      <iframe v-if="thirdPageUrl" :src="thirdPageUrl" frameborder="0" />
    </el-dialog>
    <!-- 嵌入客服 -->
    <CustomerService
      v-if="CustomerServiceVisible && token"
      :serveUrl="serveUrl"
      :request="request"
      @questionClick="questionClick"
      :CustomerServiceVisible.sync="CustomerServiceVisible"
    ></CustomerService>
    <CustomerService
      v-else-if="CustomerServiceVisible"
      openApi
      :serveUrl="serveUrl"
      :request="request"
      @questionClick="questionClick"
      :CustomerServiceVisible.sync="CustomerServiceVisible"
    ></CustomerService>
    <!-- 嵌入消息侧滑 -->
    <sw-message-dialogv2
      v-if="token && routerName === 'MyMessage'"
      :request="request"
      :base-url="messageBaseUrl"
      ref="smd"
      @refresh="refreshMessage"
      :visible.sync="messageDialog"
      :message-center="routerName"
      @updateUnreadedMessageCount="updateUnreadedMessageCount"
    ></sw-message-dialogv2>
    <sw-message-dialog
      v-else-if="token"
      :request="request"
      :base-url="messageBaseUrl"
      ref="smd"
      @refresh="refreshMessage"
      :visible.sync="messageDialog"
      :message-center="routerName"
      @updateUnreadedMessageCount="updateUnreadedMessageCount"
    ></sw-message-dialog>
    <!-- 消息配套弹出确认取消框 -->
    <!-- <el-dialog title="提示" :visible.sync="messageVisible" width="30%" :before-close="handleClose">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>-->
    <!-- 全局搜索盒子 -->
    <GlobalSearch v-if="GlobalSearchVisible" @clobalClick="exitGlobalSearch" />
  </nav>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { getToken } from '@/utils/auth'
import decodeTicket from '@/utils/decodeTicket'
import { getUserAvatar } from '@/api/user.js'
import { login, logout } from '@/utils/utils'
import * as Cookies from 'js-cookie'
import { getUnreadedMessageCount } from '@/api/message.js'
import configR from '@/configs.js'
export default {
  name: 'NavMenu',
  props: {
    changeNavStatus: {
      type: Boolean,
      default: false,
    },
    logo: {
      default: '',
    },
    systemName: {
      type: String,
      default: '一站式服务大厅',
    },
  },
  components: {
    draggable: () => import('vuedraggable'),
    DesktopConfig: () => import('./DesktopConfig'),
    GlobalSearch: () => import('./GlobalSearch'),
  },
  inject: ['reload'],
  data() {
    return {
      messageBaseUrl:
        configR.envConfigs.MESSAGE_API_URL + 'center/',
      // 桌面助手
      downloadAssistant: require('@/assets/Common/download_assistant.png'),
      // color
      color: null,
      // 预设颜色
      predefineColors: ['#0069b7', '#a40000', '#0F2050'],
      // 排序弹框
      sortVisible: false,
      // 搜索关键词
      searchKeyword: '',
      // 导航展示数量
      navNumber: 8,
      // 用户导航排序
      userNavTemp: [],
      // 拖拽配置
      dragOptions: { animation: 200 },
      // 嵌入页面
      thirdPageVisible: false,
      // 嵌入页面 URL
      thirdPageUrl: null,
      // 桌面配置
      desktopConfigVisible: false,
      // 用户中心
      userCenterVisible: false,
      // 全局搜索结果
      globalSearchKeyword: '',
      GlobalSearchVisible: false,
      // 全局搜索输入框是否显示
      globalSearchShow: true,
      // 客服显示状态
      CustomerServiceVisible: false,
      // 消息侧滑显示状态
      messageDialog: false,
      // 消息弹窗阻断获取消息事件
      messageAvilable: true, // QR
      schoolCode: configR.envConfigs.SCHOOL_CODE,
      changeThemeNavIcon: configR.envConfigs
        .CHANGE_THEME_NAV_ICON,
      routerName:
        configR.envConfigs.MYMESSAGE_AND_MESSAGECENTER ||
        'MyMessage',
      avatarImg: '',
      dialogQrCodeVisible: true, // 控制二维码弹框显示隐藏
      showNavNumberRule: [
        { serviceWidth: 1280, navNumber: 5 },
        { serviceWidth: 1160, navNumber: 4 },
        { serviceWidth: 1040, navNumber: 3 },
      ],
      ieNavagationStyle: {},
    }
  },
  directives: {
    tap: {
      bind: function (el, binding) {
        var startTx, startTy, endTx, endTy, startTime, endTime

        el.addEventListener(
          'touchstart',
          function (e) {
            var touch = e.touches[0]
            startTx = touch.clientX
            startTy = touch.clientY
            startTime = +new Date()
          },
          false
        )

        el.addEventListener(
          'touchend',
          function (e) {
            endTime = +new Date()
            if (endTime - startTime > 300) {
              // 若点击事件过长，不执行回调
              return
            }
            var touch = e.changedTouches[0]
            endTx = touch.clientX
            endTy = touch.clientY
            if (
              Math.abs(startTx - endTx) < 6 &&
              Math.abs(startTy - endTy) < 6
            ) {
              // 若点击期间手机移动距离过长，不执行回调
              var method = binding.value.method
              var params = binding.value.params
              method(params)
            }
          },
          false
        )
      },
    },
  },
  computed: {
    // getters
    ...mapGetters([
      'avatar',
      'userInfo',
      'userNav',
      'userButtons',
      'userIdentity',
      'serveUrl',
      'request',
      'token',
      'isias',
      'systemSetting',
      'themeConfig',
      'superAmin',
      'unReadedMessageCount',
    ]),
    // state
    ...mapState({
      // 首页卡片索引
      homeCarousel: (state) => state.home.homeCarousel,
    }),
    // 是否登录
    hasUserInfo() {
      return getToken()
      // return Object.keys(this.userInfo).length > 1;
    },
    // 当前导航
    currentNav() {
      if (
        this.$route.name === 'Sticker' ||
        this.$route.name === 'Carousel' ||
        this.$route.name === 'Lite' ||
        this.$route.name === 'Classic' ||
        this.$route.name === 'Index'
      ) {
        return 'Index'
      } else {
        return this.$route.name
      }
    },
    // 当前桌面
    currentDesktop() {
      return window.localStorage.Desktop
    },
    // 兼容搜狗极速浏览器，头像与logo去掉className:keep-hue
    hideKeepHue() {
      // 获取国内加壳浏览器类型 Window.external
      // SEVersion -- 搜狗浏览器
      return !!(
        window.external &&
        'SEVersion' in window.external &&
        navigator.userAgent.indexOf('WebKit') > 0
      )
    },
  },
  watch: {
    // 监听路由
    $route() {
      this.returnNavNumber()
    },
    // 监听登录
    hasUserInfo() {
      this.returnNavNumber()
    },
  },
  created() {
    decodeTicket()
    let param = {
      request: this.request,
      params: {
        token: this.token,
      },
    }
    getUserAvatar(param).then((res) => {
      try {
        this.avatarImg =
          'data:image/png;base64,' +
          btoa(
            new Uint8Array(res).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ''
            )
          )
      } catch (error) {
        this.avatarImg = window.URL
          ? window.URL.createObjectURL(res)
          : window.webkitURL.createObjectURL(res)
      }
    })
    if (this.hasUserInfo) this.$store.dispatch('getInfo')
    // 如果是IE浏览器，过渡效果去掉
    if (navigator.userAgent.indexOf('Trident') > -1) {
      this.ieNavagationStyle.transition = 'none'
    }
    if (this.$route.query.GlobalSearch) {
      this.GlobalSearchVisible = true
    }
  },
  mounted() {
    this.returnNavNumber()
    this.$store.dispatch('updateUnreadedMessageCount')
    window.addEventListener('resize', () => {
      this.returnNavNumber()
    })
    this.$bus.on('change-portrait', () => {
      let param = {
        request: this.request,
        params: {
          token: this.token,
        },
      }
      getUserAvatar(param).then((res) => {
        try {
          this.avatarImg =
            'data:image/png;base64,' +
            btoa(
              new Uint8Array(res).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ''
              )
            )
        } catch (error) {
          this.avatarImg = window.URL
            ? window.URL.createObjectURL(res)
            : window.webkitURL.createObjectURL(res)
        }
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.returnNavNumber)
    this.$bus.off('refreshMessage')
  },
  methods: {
    updateUnreadedMessageCount() {
      this.$store.dispatch('updateUnreadedMessageCount')
    },
    exitGlobalSearch(a) {
      this.GlobalSearchVisible = a
    },
    //收藏
    gotoCollections() {
      this.$router.push({
        name: 'MyCollections',
      })
    },
    //电话簿
    gotoTelecontent() {
      window.open(
        'http://my.sust.edu.cn/#/newsDetail?id=8aaa87547578cdc8017587ba81040063',
        '_blank'
      )
    },

    //跳转老门户
    gotoOldportal() {
      window.open('http://eold.jxnu.edu.cn', '_blank')
    },
    gotoOldjgsportal() {
      window.open('http://my.jgsu.edu.cn', '_blank')
    },
    // 计算导航显示数量
    returnNavNumber() {
      if (this.hasUserInfo) {
        let htmlWidth =
          document.documentElement.clientWidth || document.body.clientWidth
        if (htmlWidth > 1280) {
          this.navNumber = 8
          return false
        }
        this.showNavNumberRule.forEach((item) => {
          if (htmlWidth <= item.serviceWidth) {
            this.navNumber = item.navNumber
          }
        })
      } else {
        this.navNumber = 5
      }
    },
    // 打开排序
    openNavSort() {
      this.userNavTemp = this.userNav.filter((item) => {
        return item
      })
      this.sortVisible = true
    },
    // 确认排序
    submitNavSort() {
      // saveUserNav({ list: this.userNavTemp }).then(res => {
      //   if (res.status === 200) {
      //     // 重新获取用户导航
      //     getUserNav().then(res => {
      //       this.$store.commit("SET_USER_NAV", res.data.data.items);
      //     });
      //     this.sortVisible = false;
      //   }
      // });
    },
    // 跳转
    jumpToRoute(route, from) {
      console.log('1--', route, from, this.$route.name)
      // 关闭配置
      if (this.sortVisible) this.sortVisible = false
      // 首页刷新
      if (
        from &&
        from === 'logo' &&
        route === this.$route.name &&
        route === 'Index'
      ) {
        // this.reload();
        window.location.reload()
        return
      }
      // 相同不跳转
      console.log('2--', route, from, this.$route.name)
      if (route === this.$route.name) return
      console.log('3--', route, from, this.$route.name)
      // 跳转
      switch (route) {
        case 'ManagementCenter':
          this.thirdPageUrl = `http://portal.dice.supwisdom.com/portal-web/html/admin/index.html?access_token=${getToken()}`
          this.thirdPageVisible = true
          break
        default:
          this.$router.push({ name: route })
          console.log('4--', route, from, this.$route.name)
          break
      }
      console.log('5--', route, from, this.$route.name)
    },
    // 打开桌面配置
    openDesktopSetting() {
      this.sortVisible = false
      this.desktopConfigVisible = true
      this.thirdPageVisible = true
    },
    // 退出桌面配置
    exitDesktopConfig() {
      this.thirdPageVisible = false
    },
    //
    themeChange(val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'theme',
        value: val,
      })
    },

    // 头像菜单
    userCommand(command) {
      this.sortVisible = false
      switch (command) {
        case 'signOut':
          this.$store.dispatch('signOut').then(() => {
            Cookies.remove('isLogin')
            logout()
          })
          break
        case 'userCenter':
          if (configR.envConfigs.PERSONAL_CENTER_LINK) {
            window.open(
              configR.envConfigs.PERSONAL_CENTER_LINK
            )
          } else {
            this.$router.push({ name: 'PersonalCenter' })
          }
          break
        case 'goPlatform':
          window.open(configR.envConfigs.ADMIN_PLATFORM)
          break
      }
    },
    // 嵌入页面关闭时
    thirdPageClosed() {
      this.thirdPageUrl = ''
      this.userCenterVisible = false
      this.desktopConfigVisible = false
    },
    //登录页面跳转
    login() {
      login()
    },
    handleGetGlobalSearch() {
      if (this.globalSearchKeyword === '') return
      this.$store.commit('SET_USER_GOLBALSEARCH', this.globalSearchKeyword)
      this.$router.push({ name: 'GlobalSearch' })
    },
    searchInputBlur() {
      this.globalSearchShow = true
    },
    customerClick() {
      this.CustomerServiceVisible = true
    },
    messageClick() {
      if (this.token) {
        this.messageDialog = true
      } else {
        this.login()
      }
    },
    refreshMessage() {
      this.$bus.emit('refreshMessage')
    },
    questionClick() {
      this.CustomerServiceVisible = false
      const { href } = this.$router.resolve({
        name: 'HelpCenter',
      })
      window.open(href, '_blank')
    },
  },
}
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.nav {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
  &.changeNavStatus {
    transition: $transition-primary;
    height: 60px;
    .nav-background {
      &--hover {
        bottom: 60px;
      }
    }
    .nav-content {
      .logo {
        line-height: 60px;
        &-img {
          max-height: 20px;
        }
      }
      .nav-menu {
        height: 60px;
        line-height: 60px;
      }
    }

    .nav-menu-item-background {
      bottom: 60px;
    }
  }
  &-background {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: -1;
    display: flex;
    transition: $transition-primary;
    background-color: rgba($color: $color-primary, $alpha: 1);
    bottom: 0;

    &-stack {
      flex: 1;
      background-color: rgba($color: $color-background, $alpha: 0.4);
    }

    &--never {
      display: none;
    }

    &--hover {
      bottom: 110px;
    }
  }
  .nav-content {
    width: 1680px;
    margin: 0 auto;
    display: flex;
    @include portalMedia;
    .logo {
      margin-right: 20px;
      line-height: 110px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0;
      cursor: pointer;
      &-img {
        max-height: 50px;
        background-size: 100% 100%;
      }
    }
    .nav-menu {
      flex: 1;
      height: 110px;
      display: flex;
      line-height: 110px;
      transition: $transition-primary;

      &-item {
        // flex: 1;
        width: auto;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        color: rgba($color: #fff, $alpha: 1);
        cursor: pointer;
        padding: 0 15px;
        letter-spacing: 1px;
        opacity: 0.8;

        &:hover {
          // color: #fff;
          .nav-menu-item-background {
            z-index: 0;
            bottom: 0;
          }
        }

        &--active {
          // color: #fff;
          opacity: 1;
          font-weight: bold;
          .nav-menu-item-cursor {
            height: 2px;
          }
        }

        &-background {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 110px;
          left: 0;
          z-index: -1;
          background-color: rgba($color: #fff, $alpha: 0.1);
          transition: $transition-primary;
        }

        &-cursor {
          position: absolute;
          bottom: 24%;
          right: 0;
          left: 0;
          width: 16px;
          height: 0;
          margin: auto;
          background-color: #fff;
          border-radius: 2px;
          transition: $transition-primary;
        }
        span {
          white-space: nowrap;
        }
      }
    }
    &-iconSet {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &-desktop {
        width: 18px;
        color: #fff;
        margin-left: 20px;
        cursor: pointer;
        overflow: hidden;

        > div {
          display: flex;
          flex-direction: column;
        }

        &:hover {
          > div {
            animation: infiniteScroll 1s 1 alternate;
          }
        }
      }
      &-oldAddress {
        width: 18px;
        height: 18px;
        line-height: 18px;
        font-size: 18px;
        color: #fff;
        margin-left: 20px;
        cursor: pointer;
      }
      &-collect {
        width: 18px;
        height: 18px;
        line-height: 18px;
        font-size: 18px;
        color: #fff;
        margin-left: 20px;
        cursor: pointer;
      }
      &-telephone {
        width: 18px;
        height: 18px;
        line-height: 18px;
        font-size: 18px;
        color: #fff;
        margin-left: 20px;
        cursor: pointer;
      }

      &-login {
        display: inline-block;
        color: #fff;
        font-size: 14px;
        margin-left: 20px;
        cursor: pointer;
        letter-spacing: 1px;
        width: 30px;
      }
    }

    &-global-search {
      width: 256px;
      height: 40px;
      border-radius: 20px;
      border: none;
      transition: $transition-primary;
      background-color: rgba($color: #fff, $alpha: 0.09);

      .z-search-input {
        opacity: 0.7;
        color: #ffffff;
        border: none;

        &:focus {
          opacity: 1;
          border: none;
        }
      }

      .z-search-icon.el-icon-circle-close {
        margin-right: 18px;
      }
    }

    i.el-icon-bell,
    i.el-icon-service,
    i.el-icon-house,
    i.el-icon-monitor {
      color: #fff;
      font-size: 22px;
      margin-left: 20px;
      cursor: pointer;
    }
    i.el-icon-search {
      color: #fff;
      font-size: 22px;
      cursor: pointer;
    }
    svg.help,
    svg.desk,
    svg.erCode {
      color: #fff;
      font-size: 22px;
      margin-left: 20px;
      cursor: pointer;
    }
    svg.desk {
      font-size: 20px;
    }

    .sw-icon {
      color: #fff;
      font-size: 24px;
      margin-left: 20px;
      cursor: pointer;
    }

    .el-dropdown {
      margin-left: 20px;
      a.el-link {
        height: 100%;
      }
    }

    &-download {
      display: flex;
      justify-content: space-between;
      padding: 0;

      &-app,
      &-assistant {
        width: 120px;
        padding: 27px;

        img {
          width: 120px;
        }

        h5 {
          margin-top: 10px;
          text-align: center;
        }
      }
    }

    &-third_page {
      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }

  position: fixed;
  top: 0;
  z-index: 1999;
  width: 100%;
  height: 110px;
  color: #fff;
  box-sizing: border-box;
  transition: $transition-primary;
}
.nav-download-apps {
  display: flex;
  padding: 10px 10px 0;

  > li {
    max-width: 400px;
    padding: 10px;

    > img {
      max-width: 400px;
    }

    > h5 {
      text-align: center;
    }
  }
  .avatar {
    img {
      width: 100%;
    }
  }
}
.nav-sort {
  width: 90vw;
  box-sizing: border-box;
  background-color: rgba($color: $color-primary, $alpha: 0.8);

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 20px;
  }

  &-title {
    color: #fff;
    font-size: 18px;
    line-height: 18px;
    margin-bottom: 20px;

    span:first-child {
      margin-right: 10px;
    }

    span:nth-child(2) {
      font-size: 14px;
      opacity: 0.4;
    }
  }

  &-menu {
    display: flex;
    flex-wrap: wrap;

    &-item {
      position: relative;
      margin-right: 20px;
      margin-top: 20px;
      cursor: pointer;
    }
  }

  footer {
    display: flex;
    justify-content: center;
  }
}
.nav-avatar {
  display: flex;
  align-items: center;
}
.msgBadge {
  .el-badge__content {
    background-color: red;
    border: none;
  }
}
</style>
